import { Component, Mixins, Vue } from 'vue-property-decorator';
import ViewPage from '@/mixins/Views';
// @ is an alias to /src
@Component
export default class Login extends Mixins(ViewPage) {
  private name = 'login';
}
